<style type="text/css">
.container-feedback {
  max-width: 600px;
}
</style>

<template>
  <v-container class="container-feedback">
    <v-row>
      <v-col>
        <div style="text-align: center; padding-bottom: 30px; font-size: 20px; max-width: 600px; margin: 0 auto;">
          <div v-if="status === 'loading'" style="display: flex; gap: 20px; justify-content: center;">
            <v-progress-circular
              :size="30"
              :width="2"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <div>...working on the order</div>
          </div>

          <div v-if="status === 'loaded'">
            <v-icon color="success" style="font-size: 80px;">mdi-shopping-outline</v-icon>
            <div style="margin-top: 30px;">Thank you for your purchase!</div>

            <div style="margin-top: 30px;">Here is your link to</div>
            <div style="font-weight: bold;">{{ lastOrder.name }}</div>

            <div style="margin-top: 20px;">
              <v-btn
                color="primary"
                style="padding: 17px 12px;"
                :href="lastOrder.gsUrl"
                target="_blank"
              >
                <v-icon light style="margin-right: 10px;">mdi-google-spreadsheet</v-icon>
                {{ translate('ui_gs_file_url') }}
              </v-btn>
            </div>

            <div style="margin-top: 40px;">
              We have also emailed the link to<span style="font-weight: bold; margin-left: 10px;">{{ this.lastOrder.email }}</span>
            </div>

            <div style="font-size: 16px; max-width: 400px; margin: 50px auto 20px;">
              <div>Please let us know if you have any issues<br>accessing your file</div>
              <v-btn
                small
                :href="`/builder/#/feedback?email=${this.lastOrder.email}`"
                outlined style="margin-top: 20px;"
              ><v-icon>mdi-message-outline</v-icon>
                <span style="padding-left: 10px;">
              Send message
            </span>
              </v-btn>
            </div>
          </div>

          <div v-if="status === 'error'">
            <div style="margin-top: 30px;">Our apologies, but we couldn't find the order</div>

            <div style="font-size: 18px; max-width: 500px; margin: 50px auto 20px;">
              <div>Please try refreshing the page.</div>
              <div>If this doesn't help, don't worry and send us a message</div>
              <v-btn
                href="/builder/#/feedback"
                color="primary"
                style="margin-top: 40px;"
              ><v-icon>mdi-message-outline</v-icon>
                <span style="padding-left: 10px;">
              Send message
            </span>
              </v-btn>
            </div>
          </div>

        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// mixins
import Mixin from '../mixins/mixin';

export default {
  mixins: [Mixin],
  data: () => ({
    status: 'loading',
    lastOrder: {},
  }),
  methods: {},
  mounted() {
    const arr = window.location.hash.split('?orderId=');
    const that = this;
    if (arr[1]) {
      const orderId = arr[1];
      this.interval = window.setInterval(async () => {
        await this.$store.dispatch('getUserData');
        const userOrders = this.$store.state.user.orders;
        if (userOrders && userOrders.length > 0 && userOrders.find((order) => order.orderId === orderId)) {
          that.lastOrder = userOrders[userOrders.length - 1];
          this.status = 'loaded';
          window.clearInterval(this.interval);
        }
      }, 1000);
    } else {
      this.status = 'loaded';
      // alert('Error processing order, please reach out at info@finmodelbuilder.com');
    }
    // fallback in case something goes wrong
    setTimeout(() => {
      if (that.status === 'loading') {
        that.status = 'error';
        window.clearInterval(this.interval);
      }
    }, 20000);
  },
};

</script>
